import PropTypes from 'prop-types';
import { FormControl, makeStyles, TextField } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import * as React from 'react';
import { appColors } from 'styles/colors';

const useStylesSelectLabel = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& label': {
      color: appColors.field.normal,
      marginBottom: 4,
    },
    '& label.Mui-focused': {
      color: appColors.field.primary,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: appColors.field.primary,
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: 19.5,
      paddingBottom: 19.5,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: appColors.field.normal,
      },
      '&:hover fieldset': {
        borderColor: appColors.field.hover,
      },
      '&.Mui-focused fieldset': {
        borderColor: appColors.field.primary,
      },
    },
  },
  inputLabel: {
    color: appColors.primary,
    marginBottom: 4,
  },
  formControl: {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
    minWidth: 120,
  },
  selectEmpty: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
}));

export default function NewSelectMultipleV2({
  label,
  input,
  meta: { touched, error } = {},
  options,
  disabled,
  value,
  onChange,
  isDashProductOrders,
}) {
  const classes = useStylesSelectLabel();
  const [option, setOption] = React.useState([]);
  const allOption = { id: 'all', title: 'Todos', start: '' };

  React.useEffect(() => {
    if (Array.isArray(value)) {
      setOption(value);
    } else {
      setOption([]);
    }
  }, [value]);

  function handleChange(event, value) {
    if (value.some((item) => item.id === 'all')) {
      const newSelection = option.length === options.length ? [] : [...options];
      setOption(newSelection);
      onChange(newSelection);
    } else {
      setOption(value);
      onChange(value);
    }
  }

  function toggleSelection(selectedOption) {
    let newSelection;
    if (selectedOption.id === 'all') {
      newSelection = option.length === options.length ? [] : [...options];
    } else if (option.some((item) => item.id === selectedOption.id)) {
      newSelection = option.filter((item) => item.id !== selectedOption.id);
    } else {
      newSelection = [...option, selectedOption];
    }
    setOption(newSelection);
    onChange(newSelection);
  }

  function renderSelectedValues(selected) {
    if (selected.length === 0) return '';
    if (selected.length === options.length) return 'Todos';
    if (selected.length === 1) return selected[0].title;
    return `${selected[0].title}, +${selected.length - 1}`;
  }

  return (
    <div className={classes.root}>
      <FormControl
        aria-label="Tooltip do Formulário"
        variant="outlined"
        color="primary"
        className={classes.formControl}>
        <Autocomplete
          id="tags-outlined"
          multiple
          disableCloseOnSelect
          filterSelectedOptions={false}
          options={[allOption, ...options]}
          value={option}
          onChange={handleChange}
          getOptionLabel={(option) => option?.title}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => <TextField {...params} variant="standard" label={label} />}
          renderTags={(selected) => renderSelectedValues(selected)}
          renderOption={(props, option, { selected }) => (
            <li {...props} onClick={() => toggleSelection(option)}>
              <input type="checkbox" checked={selected} style={{ marginRight: 8 }} readOnly />
              {isDashProductOrders ? option.title : option.title + '-' + option.start}
            </li>
          )}
          disabled={disabled}
        />
      </FormControl>
    </div>
  );
}

NewSelectMultipleV2.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.shape({
      length: PropTypes.number,
    }),
  }),
  label: PropTypes.any,
  meta: PropTypes.shape({
    touched: PropTypes.any,
    error: PropTypes.any,
  }),
  options: PropTypes.any,
};
